module.exports = __webpack_public_path__ + "static/media/release-mobile.0cd779ac.jpg";